interface StubTabProps {
  title: string;
  description: string;
  itemCount: number;
}

export function StubTab({ title, description, itemCount }: StubTabProps) {
  return (
    <div className="card">
      <div className="card-body">
        <h2 className="h3">{title}</h2>
        <p className="text-secondary">{description}</p>
        <div className="mt-4">
          <span className="badge bg-blue-lt me-2">
            {itemCount} item{itemCount === 1 ? '' : 's'} in this stage
          </span>
          <span className="text-secondary">— UI not yet built. Coming next session.</span>
        </div>
      </div>
    </div>
  );
}
